export default {
  user: {
    login: {
      error: {
        message: {
          required: 'Missing required fields.',
          incorrect: 'Incorrect username or password.',
        },
        username: {
          required: 'Username is required.',
        },
        password: {
          required: 'Password is required.',
        },
      },
      currentlySignedInAs: 'Currently signed in as',
    },
  },
}
